export default __webpack_public_path__ + "static/loghi-80a5c08570eb3a2d3fb7c85afc5ffe6d.svg";